import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class InitState extends BaseState {
    public begin() {
        const nextRound = this._model.initData.next_round
        const isFsRestore =
            !Array.isArray(nextRound) &&
            String((nextRound as any)?.type || '')
                .toLowerCase()
                .startsWith('freespin')
        if (isFsRestore && this._model.spinData?.freebet != null) {
            this._model.isFreeSpinsRestore = true
        }
        GameSignals.init.emit(this._model.initData)
        this.end()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.DISPLAY_SPLASH_SCREEN_STATE)
    }

    public cleanUp() {
        // empty
    }
}
